<template>
  <div id="main">
    <el-header style="padding: 0px; height: 80px">
      <HeaderNav></HeaderNav>
    </el-header>
    <el-container style="width: 100%; height: calc(100% - 80px)">
      <el-aside style="width: 12%; height: 100%">
        <AsideNav></AsideNav>
      </el-aside>
      <el-main style="padding: 0px; width: 88%; height: 100%">
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue"
import AsideNav from "@/components/AsideNav.vue"

export default {
  name: "layout",
  components: {
    HeaderNav,
    AsideNav
  },
}
</script>

<style scoped>
#main {
  margin: 0px;
  padding: 0px;
  height: 100%;
  width: 100%;
}
.el-header {
  width: 100%;
  height: 200px;
  padding: 0px;
}
</style>